// extracted by mini-css-extract-plugin
export var orderDetails = "_lp-2";
export var orderImage = "_lp-1";
export var orderMeta = "_lp-3";
export var orderSummary = "_lp-0";
export var rightArrow = "_lp-4";